/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// MENU
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	menu: {
		position: 'relative',

		// menu items
		'& .menuitems': {
			display: 'flex',
	        flexDirection: 'column',
	        alignItems: 'center',
	        position: 'absolute',
			top: '150%',
			left: '50%',
			transition: 'all .1s ease-out 0s',
	        '& .arrow': {
	            alignSelf: 'center',
				width: '0',
				height: '0',
				boxSizing: 'border-box',
				marginBottom: pxToEm(-10),
				border: replacePXinStringWithEM(`10px solid ${theme.color.light.light.swatch}`),
				borderColor: `transparent transparent ${theme.color.light.light.swatch} ${theme.color.light.light.swatch}`,
				transform: 'rotate(135deg)',
				boxShadow: replacePXinStringWithEM(`-1px 1px 1px 0 rgba(0, 0, 0, 0.1)`)
	        },
	        '& .items': {
				background: theme.color.light.light.swatch,
				borderRadius: pxToEm(5),
				boxShadow: theme.boxShadow.small
			}
		},

		// ----- states ----- //
		'&.active-true': {
			'& .menuitems': {
				opacity: '1',
				transform: 'translateX(-50%) scale(1)',
				zIndex: '2'
			}
		},
		'&.active-false': {
			'& .menuitems': {
				opacity: '0',
				transform: 'translateX(-50%) scale(0)',
				zIndex: '-1'
			}
		}
	}
});